import * as React from "react";
const HomeCareAndIndustrialCleaningSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M30 26h-2v-9l.293.293a1.001 1.001 0 1 0 1.415-1.418L17.413 3.585a2 2 0 0 0-2.828 0L2.293 15.875a1 1 0 0 0 1.414 1.414L4 17v9H2a1 1 0 0 0 0 2h28a1 1 0 1 0 0-2ZM6 15 16 5l10 10v11h-6v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7H6V15Zm12 11h-4v-6h4v6Z"
    />
  </svg>
);
export default HomeCareAndIndustrialCleaningSVG;
